<template>
    <CagButton
        no-border
        class="user-menu-button"
        @click.native="goToRoute(routeName)"
    >
        <IconBase
            :key="iconName"
            :icon-name="iconName"
            class="icon"
            aria-hidden="true"
        />
        <span class="label"><slot /></span>
    </CagButton>
</template>

<script>
import CagButton from '@/components/global/cag-button';
import IconBase from '@/components/global/icon-base';

export default {
    name: 'UserMenuButton',
    components: {
        CagButton,
        IconBase,
    },
    props: {
        routeName: {
            type: String,
            required: true,
        },
        iconName: {
            type: String,
            required: true,
        },
    },
    methods: {
        goToRoute(routeName) {
            if (this.$route.name !== routeName) {
                this.$router.push({ name: routeName }).catch(() => {}); // Suppress navigation errors
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.user-menu-button {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding-right: 0.5rem;
    padding-left: 0.5rem;
}
.label {
    margin-top: 0.5rem;
    margin-left: 0;
}
</style>
